import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import CollectionComponent from '../components/collection.component';
import { lmsCollections } from '../../../../../../redux/lms/collections/action';
import { selectLMSCollectionsQueryItems } from '../../../../../../redux/lms/collections/selector';
import { lmsTopics } from '../../../../../../redux/lms/topics/action';
import { selectLMSTopicsListItems } from '../../../../../../redux/lms/topics/selector';

const ManagementLMSCollection = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const lmsCollectionsQuery = useSelector(selectLMSCollectionsQueryItems)
  const topicsListItems = useSelector(selectLMSTopicsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectLMSCollections, setSelectLMSCollections] = useState<any>(
    {}
  );
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])

  const fetchLMSCollectionsQueryById = () => {
    dispatch(lmsCollections.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/collections/query`,
      entity: 'lmsCollections',
      jsonData: {
        records: [
          {
            id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  // media handle form change
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSCollections({ ...selectLMSCollections, [field]: event })
  }
  useEffect(
    () => {
      dispatch(lmsTopics.list({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/topics/list`,
        entity: 'lmsTopics', jsonData: {
        }
      }))

        .then(() => {
          if (parmas?.id > 0) {
            fetchLMSCollectionsQueryById()

          } else {
            setIsLoading(false)
          }
        })
    },
    []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectLMSCollections(lmsCollectionsQuery?.result?.items)
    }
  }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

     mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const eventData = {
      "Id": selectLMSCollections?.Id || 0,
      "Title": selectLMSCollections?.Title || '',
      "Description": selectLMSCollections?.Description || '',
      "MappedTopics": {
        "MappedTopicIds": [].concat(selectLMSCollections?.MappedTopicIds || 0)
      },
      "MediaMappings": {
          "MediaFiles": mediaFiles,
          "Templates": []
      }
    };
    if (parmas?.id > 0) {
      await dispatch(lmsCollections.resetAction({ actionType: 'update' }))
      await dispatch(lmsCollections.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/collections`,
        entity: 'lmsCollections',
        jsonData: {
          records: [
            eventData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(lmsCollections.resetAction({ actionType: 'create' }))
      await dispatch(lmsCollections.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/collections`,
        entity: 'lmsCollections',
        jsonData: {
          records: [
            eventData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/lms/collections')
  }

  return (
    <>
      {lmsCollectionsQuery?.isLoading ? <PageLoader /> :
        <CollectionComponent
          handleInnerFormChange={handleInnerFormChange}
          selectLMSCollections={selectLMSCollections}
          back={back}
          handleFormSubmit={handleFormSubmit}
           onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
          TopicsList={topicsListItems?.result?.items}

        />
      }
    </>
  )
}

export default ManagementLMSCollection;